import { render, staticRenderFns } from "./anamneseDashboardSearch.vue?vue&type=template&id=0fc8fcbc&scoped=true"
import script from "./anamneseDashboardSearch.vue?vue&type=script&lang=js"
export * from "./anamneseDashboardSearch.vue?vue&type=script&lang=js"
import style0 from "./anamneseDashboardSearch.vue?vue&type=style&index=0&id=0fc8fcbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc8fcbc",
  null
  
)

export default component.exports